// Bundle Monaco locally (no CDN) and register the editor + language workers for Vite.
import { loader } from "@monaco-editor/react";
import * as monaco from "monaco-editor";
import EditorWorker from "monaco-editor/editor/editor.worker.js?worker";
import HtmlWorker from "monaco-editor/language/html/html.worker.js?worker";
import JsonWorker from "monaco-editor/language/json/json.worker.js?worker";

declare global {
  interface Window {
    MonacoEnvironment?: monaco.Environment;
  }
}

self.MonacoEnvironment = {
  getWorker: (_id: string, label: string) => {
    if (label === "json") return new JsonWorker();
    if (label === "html" || label === "handlebars" || label === "razor") return new HtmlWorker();
    return new EditorWorker();
  },
};

loader.config({ monaco });

// Jinja2 template highlighting on top of plain text: {{ }}, {% %}, {# #} and [TOKEN] brackets.
monaco.languages.register({ id: "jinja" });
monaco.languages.setMonarchTokensProvider("jinja", {
  tokenizer: {
    root: [
      [/\{\{/, { token: "delimiter.jinja", next: "@expr" }],
      [/\{%/, { token: "keyword.jinja", next: "@stmt" }],
      [/\{#/, { token: "comment.jinja", next: "@comment" }],
      [/\[[A-Za-z_][\w.]*\]/, "variable.legacy"],
      [/[^{[]+/, ""],
      [/./, ""],
    ],
    expr: [
      [/\}\}/, { token: "delimiter.jinja", next: "@pop" }],
      [/\|\s*[a-zA-Z_]\w*/, "type.filter"],
      [/"[^"]*"|'[^']*'/, "string"],
      [/\d+(\.\d+)?/, "number"],
      [/[a-zA-Z_]\w*/, "variable"],
      [/./, "delimiter"],
    ],
    stmt: [
      [/%\}/, { token: "keyword.jinja", next: "@pop" }],
      [/\b(if|elif|else|endif|for|endfor|in|set|macro|endmacro|block|endblock|include|import|with|endwith|raw|endraw|not|and|or|is)\b/, "keyword"],
      [/"[^"]*"|'[^']*'/, "string"],
      [/\d+(\.\d+)?/, "number"],
      [/[a-zA-Z_]\w*/, "variable"],
      [/./, "delimiter"],
    ],
    comment: [
      [/#\}/, { token: "comment.jinja", next: "@pop" }],
      [/./, "comment.jinja"],
    ],
  },
});
monaco.editor.defineTheme("rs-dark", {
  base: "vs-dark",
  inherit: true,
  rules: [
    { token: "delimiter.jinja", foreground: "d2a8ff" },
    { token: "keyword.jinja", foreground: "ff7b72" },
    { token: "comment.jinja", foreground: "8b949e" },
    { token: "variable.legacy", foreground: "79c0ff" },
    { token: "type.filter", foreground: "ffa657" },
  ],
  colors: {},
});
monaco.editor.defineTheme("rs-light", {
  base: "vs",
  inherit: true,
  rules: [
    { token: "delimiter.jinja", foreground: "8250df" },
    { token: "keyword.jinja", foreground: "cf222e" },
    { token: "comment.jinja", foreground: "6e7781" },
    { token: "variable.legacy", foreground: "0550ae" },
    { token: "type.filter", foreground: "953800" },
  ],
  colors: {},
});

export { monaco };
